<tr>
    <td>{{ sceneIndex + 1 }}</td>
    <td>
        <canvas #drawCanvas 
                width="480" 
                height="270"
                (mousedown)="onMouseDown($event)"
                (mousemove)="onMouseMove($event)"
                (mouseup)="onMouseUp()"
                (mouseleave)="onMouseUp()"
                (touchstart)="onTouchStart($event)"
                (touchmove)="onTouchMove($event)"
                (touchend)="onTouchEnd($event)">
        </canvas>
    </td>
    <td>
        <textarea [(ngModel)]="scene.textValue"
                  (input)="onTextChange($event)"
                  [placeholder]="i18n.t('storyboard.sceneTextPlaceholder')">
        </textarea>
    </td>
    <td>
        <div class="image-container" *ngIf="hasImage">
            <img [src]="displayImageUrl" class="image-created" [alt]="'Scene ' + (sceneIndex + 1)" />
            <button class="express-edit-button" (click)="openExpressEditor()">
                <img src="./assets/icon_express.png" alt="Express"><span>Edit</span>
            </button>
        </div>
        <app-loading *ngIf="scene.loading" [message]="i18n.t('common.generatingImage')"></app-loading>
    </td>
</tr>